import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'

import reducers from './reducers'

export default function configureStore() {
  const middlewares = [thunk]
  if (ENV === 'development') {
    const { createLogger } = require('redux-logger')
    const logger = createLogger({ collapsed: true })
    middlewares.push(logger)
  }
  const store = createStore(reducers, applyMiddleware(...middlewares))

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const nextRootReducer = require('./reducers')
      store.replaceReducer(nextRootReducer.default)
    })
  }

  return store
}
